export const PPM_BUSINESS_UNITS = [
  'LND',
  'CDC',
  'STO',
  'SHC',
  'DT',
  'CSC',
  'SO',
  'BSU',
  'DSU',
];

export const filterBusinessUnits = (businessUnits) =>
  businessUnits.filter((bu) =>
    PPM_BUSINESS_UNITS.includes(bu.businessUnitType),
  );
